<nb-card class="user-filter-container"
         [nbSpinner]="(actionType === 'Edit' || actionType === 'View') ? (loadingUserFilterDetails && !abstractFacade.state().isUserFilterDetailsError) : false">
    <nb-card-header class="header d-flex align-items-center p-0">
        <morva-icons
                class="cursor-pointer my-0 mx-3"
                icon="close"
                (click)="closeDialog()"
        ></morva-icons>
        <p data-testid="userfilter-action-header-text" class="header-text m-0">{{headerText}}</p>
    </nb-card-header>
    <nb-card-body>
        <section class="d-flex align-items-center mt-3">

            <span class="col-4 title-option">نام فیلتر کاربری</span>
            <span *ngIf="actionType === 'View'" class="col-4 title-option">{{userFilter.name}}</span>
            <input *ngIf="actionType !== 'View'" nbInput fullWidth class="name-user-filter" type="text" placeholder="ﻧﺎم فیلتر ﮐﺎرﺑﺮی را وارد ﮐﻨﯿﺪ." [(ngModel)]="userFilterName" (ngModelChange)="validator()" (click)="setSelectedUserOrGroup(undefined)">

        </section>

        <section class="d-flex align-items-center mt-3" *ngIf="actionType === 'View'">
            <span class="col-4 title-option">منبع‌داده</span>
            <span *ngIf="actionType === 'View'" class="col-4 title-option py-1 px-2">{{userFilterDetails?.dataSourceName}}</span>
        </section>

        <section class="d-flex align-items-center mt-3" [ngClass]="{'mt-5': actionType !== 'View'}">

            <span class="col-4 title-option">ستون منبع‌داده</span>
            <span *ngIf="actionType === 'View'" [ngClass]="{'type-quality': userFilterDetails?.columnDataModuleType === 'Quality',
                 'type-quantity': userFilterDetails?.columnDataModuleType === 'Quantity'}"
                  class="col-4 title-option py-1 px-2">{{userFilterDetails?.columnName}}</span>
            <button *ngIf="!selectedColumn && actionType !== 'View'" nbButton class="select-column px-3 py-1" [mat-menu-trigger-for]="selectColumn">
                <morva-icons icon="add" class="icon-16"></morva-icons>
                انتخاب ستون
            </button>

            <div *ngIf="selectedColumn && actionType !== 'View'"
                 [ngClass]="{'type-quality': selectedColumn.dataModuleType === 'Quality',
                 'type-quantity': selectedColumn.dataModuleType === 'Quantity'}"
                 class="d-flex justify-content-between align-items-center p-1">
                <span class="column-name me-2" [nbTooltip]="selectedColumn.name">{{selectedColumn.name}}</span>
                <morva-icons
                        *ngIf="actionType === 'Create'"
                        class="cursor-pointer icon-12"
                        icon="close"
                        (click)="deleteColumn()"
                ></morva-icons>
            </div>

            <mat-menu #selectColumn="matMenu">
                <input #searchColumnKey nbInput fullWidth class="search-box mt-2 mx-1" type="text" placeholder="جستجو"  (click)="$event.stopPropagation()"
                       (input)="searchColumn(searchColumnKey.value)">
                <div class="d-flex flex-column justify-content-start pb-2 px-2 menu-items">
                    <div class="d-flex justify-content-start align-items-center mt-2 cursor-pointer" (click)="changeSelectColumn(column , index)"
                        *ngFor="let column of showColumns; let index = index">
                        <morva-icons [icon]="column.dataModuleType === 'Quantity' ? 'quantity' : 'quality'" class="icon-12 ms-2"></morva-icons>
                        <span class="column-name" [nbTooltip]="column.name">{{column.name}}</span>
                    </div>
                </div>
            </mat-menu>
        </section>

        <section class="d-block mt-5">
            <span class="title-option mb-1">{{userAndValueTitle}}</span>
            <div class="d-flex justify-content-between align-items-center">

                <!-- users and groups -->
                <div class="d-flex flex-column align-items-start list-container position-relative">
                    <span class="list-title align-self-start p-1 border-bottom">ﻧﺎم ﮐﺎرﺑﺮ یا گروه کاربری</span>
                    <span class="list-title align-self-start p-2" *ngIf="!selectedColumn && actionType !== 'View'">ابتدا ستون را انتخاب کنید.</span>
                    <span class="list-title align-self-start p-2"
                          *ngIf="selectedColumn && selectedUsersOrGroupsInUserFilter.length === 0 && actionType !== 'View'">ابتدا کاربر یا گروه کاربری مورد نظر خود را اضافه کنید.</span>
                    <input #searchInUsersKey nbInput class="search-box align-self-center mt-1" type="text"
                           placeholder="جستجو" (click)="$event.stopPropagation()" (input)="searchInUsers(searchInUsersKey.value)"
                           *ngIf="(selectedColumn || actionType === 'View')
                           && selectedUsersOrGroupsInUserFilter.length > 0">
                    <div class="list-overflow-users-groups scroll-list w-100" [ngClass]="{'h-100': actionType === 'View'}">
                        <div *ngFor="let item of showSelectedUsersOrGroupsInUserFilter"
                             class="d-flex justify-content-between align-items-center cursor-pointer w-100 p-2"
                             [ngClass]="(selectedUserOrGroupInUserFilter?.userFilterRecipientId ===
                         item.userFilterRecipientId) ? 'highlight-item':  'deselect-item'"
                             (click)="setSelectedUserOrGroup(item)">
                            <div class="d-flex justify-content-start align-items-center">
                                <morva-icons [icon]="item.userFilterRecipientType === 'Solo' ? 'person' : 'people'" class="icon-12 mt-0"></morva-icons>
                                <span class="text mx-1" [nbTooltip]="item.recipientName+ ' ('+ item.selectedValues.length + ')'">{{item.recipientName}} ({{item.selectedValues.length}})</span>
                            </div>
                            <div *ngIf="actionType !== 'View'" class="d-flex justify-content-end align-items-center me-auto">
                                <morva-icons *ngIf="actionType === 'Edit' && item.selectedValues.length === 0" icon="warning"
                                             nbTooltip="هیچ مقداری برای کاربر انتخاب نشده است." class="icon-12 mt-0 mx-1"></morva-icons>
                                <morva-icons icon="minus" class="icon-12 mt-0 cursor-pointer" (click)="removeUserOrGroup(item)"></morva-icons>
                            </div>
                        </div>
                    </div>
                    <span class="d-flex justify-content-start align-self-start w-100 my-2 mx-1 position-absolute bottom-0 cursor-pointer box-shadow"
                          *ngIf="selectedColumn && actionType !== 'View'" [mat-menu-trigger-for]="selectUser">
                        <morva-icons icon="add" class="icon-16 mt-0 ms-1 blue-tart-icon"></morva-icons>
                        <small class="add-user-filter">اﻓﺰودن کاربر یا گروه کاربری</small>
                    </span>

                    <mat-menu #selectUser="matMenu">
                        <input #searchUserOrGroupKey nbInput fullWidth class="search-box mt-2 mx-1" type="text"
                               placeholder="جستجو" (input)="searchUserOrGroup(searchUserOrGroupKey.value)" (click)="$event.stopPropagation()">
                        <div class="d-flex flex-column justify-content-start pb-2 px-2 menu-items">
                            <div class="d-flex justify-content-start align-items-center cursor-pointer my-2"
                                 *ngFor="let userOrGroup of showUsersAndGroups" (click)="addUserOrGroupToUserFilter(userOrGroup)">
                                <morva-icons [icon]="userOrGroup.userFilterRecipientType === 'Solo' ? 'person' : 'people'" class="icon-12 ms-2"></morva-icons>
                                <span class="column-name" [nbTooltip]="userOrGroup.recipientName">{{userOrGroup.recipientName}}</span>
                            </div>
                        </div>
                    </mat-menu>
                </div>

                <!-- selected column values -->
                <div class="d-flex flex-column list-container position-relative">
                    <span class="list-title align-self-start p-1 border-bottom">ﻣﻘﺎدﯾﺮ ستون</span>
                    <span class="list-title align-self-start p-2" *ngIf="!selectedColumn && actionType !== 'View'">ابتدا ستون را انتخاب کنید.</span>
                    <input #searchColumnValueKey nbInput fullWidth class="search-box align-self-center mt-1" type="text" placeholder="جستجو"
                           (click)="$event.stopPropagation()" [ngClass]="{'not-show': !selectedColumn && actionType !== 'View'}">
                    <div *ngIf="this.actionType !== 'View'" class="list-overflow-values scroll-list py-2" [style.overflow]="!selectedUserOrGroupInUserFilter ? 'hidden' : 'auto'"
                         [nbSpinner]="loadingColumnValues" (scroll)="onScroll($event)">
                        <div *ngFor="let value of  showSelectedColumnValues; let index = index"
                             class="d-flex justify-content-start align-items-center mx-2" >
                            <nb-checkbox [checked]="value.isChecked" (checkedChange)="chooseColumnValue($event, value.value, index)" [disabled]="!selectedUserOrGroupInUserFilter">
                            </nb-checkbox>
                            <span class="text mx-2" [nbTooltip]="value.value" [style.opacity]="selectedUserOrGroupInUserFilter === undefined ? 0.5 : 1">{{value.value}}</span>
                        </div>
                    </div>

                    <div class="list-overflow-values scroll-list h-100 py-2"  *ngIf="actionType === 'View'" [nbSpinner]="loadingColumnValues">
                        <div *ngFor="let value of  showSelectedValues; let index = index"
                             class="d-flex justify-content-start align-items-center mx-2 py-1" >
                            <span class="text mx-2" [nbTooltip]="value" [style.opacity]="selectedUserOrGroupInUserFilter === undefined ? 0.5 : 1">{{value}}</span>
                        </div>
                    </div>

                    <div *ngIf="actionType !== 'View'" class="d-flex align-items-center me-1 pt-1 mt-1 w-100 position-absolute bottom-0 box-shadow">
                        <nb-checkbox [checked]="selectedUserOrGroupInUserFilter ? !selectedUserOrGroupInUserFilter.isInclude : false" (checkedChange)="toggleIsInclude()">
                        </nb-checkbox>
                        <span class="text-exclude mx-1">شامل موارد انتخاب‌شده نشود.(exclude)</span>
                    </div>
                </div>

            </div>
        </section>

    </nb-card-body>
    <nb-card-footer *ngIf="actionType !== 'View'" class="d-flex justify-content-end align-items-center me-auto">
        <button  nbButton class="cancel-button mx-1" (click)="closeDialog()">
            انصراف
        </button>
        <button *ngIf="actionType === 'Create'" nbButton [ngClass]="isValidated ? 'submit-button':'deactive-submit-button'"
                (click)="createUserFilter()" [disabled]="!isValidated" [nbSpinner]="submitting">
            ایجاد
        </button>
        <button *ngIf="actionType === 'Edit'" nbButton [ngClass]="isValidated ? 'submit-button':'deactive-submit-button'"
                (click)="editUserFilter()" [disabled]="!isValidated" [nbSpinner]="submitting">
            ذخیره
        </button>
    </nb-card-footer>
</nb-card>
